import { Skeleton } from '@antimatterhq/ui/components/skeleton';
import { count, formatPercentage } from '@antimatterhq/ui/utils/format';
import { Icon } from '@antimatterhq/ui/components/icon';
import { Text } from '@antimatterhq/ui/components/typography';
import Tooltip from '@antimatterhq/ui/components/tooltip';

interface TrendProps {
  label: string;
  value: number | undefined;
  summarizeCount?: boolean;
  isFetching?: boolean;
  trend: {
    startingValue: number;
    endingValue: number;
  };
}

export const Trend = ({
  label,
  value,
  summarizeCount,
  isFetching,
  trend,
}: TrendProps) => {
  const trendDelta = trend.endingValue - trend.startingValue;
  const percentageChange = formatPercentage(
    (trendDelta / trend.startingValue) * 100,
  );
  const tooltipContent =
    trendDelta === 0 ? 'No change' : `${percentageChange}% Change`;

  return (
    <div className="flex flex-col">
      <Text>{label}</Text>
      <span className="flex items-center gap-2">
        {isFetching ? (
          <Skeleton className="h-9 w-[50%]" />
        ) : (
          <Text size="2xl" bold>
            {summarizeCount ? count(value ?? 0) : value}
          </Text>
        )}
        <Tooltip content={tooltipContent} side="bottom">
          {isFetching === true ? null : trendDelta > 0 ? (
            <Icon
              icon="lucide:trending-up"
              className="text-2xl text-blue-400"
            />
          ) : trendDelta < 0 ? (
            <Icon
              icon="lucide:trending-down"
              className="text-2xl text-blue-400"
            />
          ) : (
            <Icon icon="lucide:minus" className="text-2xl text-blue-400" />
          )}
        </Tooltip>
      </span>
    </div>
  );
};
